var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 7.13488L7.07516 8.38988C7.45516 8.61988 7.92016 8.27988 7.82016 7.84988L7.27016 5.48988L9.10516 3.89988C9.44016 3.60988 9.26016 3.05988 8.82016 3.02488L6.40516 2.81988L5.46016 0.589883C5.29016 0.184883 4.71016 0.184883 4.54016 0.589883L3.59516 2.81488L1.18016 3.01988C0.740158 3.05488 0.560158 3.60488 0.895158 3.89488L2.73016 5.48488L2.18016 7.84488C2.08016 8.27488 2.54516 8.61488 2.92516 8.38488L5.00016 7.13488Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLight);
export default __webpack_public_path__ + "static/media/star_light.25b5924351688a6856c3a21c3a9ec8a4.svg";
export { ForwardRef as ReactComponent };